import { ComponentsOverrides, ComponentsProps, Theme } from "@mui/material";
import { CSSObject } from "@mui/system";

import pxToRem from "@/themes/functions/pxToRem";

interface IIcon {
  defaultProps: ComponentsProps["MuiIcon"];
  styleOverrides: ComponentsOverrides<Theme>["MuiIcon"];
}

const icon: IIcon = {
  defaultProps: {
    baseClassName: "material-icons-round",
    fontSize: "inherit",
  },

  styleOverrides: {
    fontSizeInherit: {
      fontSize: "inherit !important",
    } as CSSObject,

    fontSizeSmall: {
      fontSize: `${pxToRem(20)} !important`,
    } as CSSObject,

    fontSizeLarge: {
      fontSize: `${pxToRem(36)} !important`,
    } as CSSObject,
  },
};

export default icon;
